export interface SelectOption {
  title: string;
  value: string;
  customClass?: string;
  disabled?: boolean;
  id?: string;
  tooltipText?: string;
}

export enum SelectEvents {
  SELECTION_CHANGED = 'selectionChanged',
  OVERLAY_CLOSED = 'overlayClosed',
}

export enum OverlayPositionX {
  LEFT = 'left',
  RIGHT = 'right',
}
